import { getInitData } from '@/utils/getInitData';
import { settings } from '@/api/config';
import axios from 'axios';

export const getCases = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/events/safe?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};

export const getCaseData = async (safe_id: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/events/safe/${safe_id}?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};

export const openCase = async (safe_id: string, code: number[]) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/events/safe/${safe_id}/open?initData=${encodedInitData}`,
      {
        code,
      },
    );
    return response.data;
  } catch (error: any) {
    return error.response.data;
  }
};

export const checkSubscription = async (safe_id: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/events/safe/${safe_id}/check-subscription?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const getLeaderboard = async (safe_id: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/events/safe/${safe_id}/leaders?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const sendProviderInfo = async (provider: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/events/safe/banners/${provider}/view?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const getCaseUpdateTime = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(`${settings.url}api/events/safe/next-day`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const getLimit = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/banners/get_count_views/banners-cpm?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const getAttemptsInfo = async (safe_id: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/events/safe/${safe_id}/attempts/today?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const getSafeTasks = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/tasks/safe/get?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const checkConditions= async (safe_id: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(
      `${settings.url}api/events/safe/${safe_id}/check-tasks?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};

export const getMessage = async (type: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(`${settings.url}api/users/forward-message/${type}?initData=${encodedInitData}`);
    return response.data; 
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};


export const recordSendProgress = async (safe_id: string, task_id: string) => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.post(`${settings.url}api/events/safe/${safe_id}/record-task/${task_id}?initData=${encodedInitData}`);
    return response.data;
  } catch (error) {
    console.error('Ошибка при открытии сейфа:', error);
    throw error;
  }
};